/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.2.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NextPortArrival
 */
export interface NextPortArrival {
    /**
     * 
     * @type {number}
     * @memberof NextPortArrival
     */
    imo: number;
    /**
     * Estimated Time of Arrival (ETA) in ISO Extended format (UTC). Only present on prediction records; omitted when the ship has already arrived or no prediction could be made.
     * @type {string}
     * @memberof NextPortArrival
     */
    eta?: string;
    /**
     * Actual Time of Arrival (ATA) in ISO Extended format (UTC). When present, this record is the vessel's current port call rather than a prediction, and `eta`/`probability` are omitted.
     * @type {string}
     * @memberof NextPortArrival
     */
    ata?: string;
    /**
     * UNLOCODE
     * @type {string}
     * @memberof NextPortArrival
     */
    locode: string;
    /**
     * ID for the current trip for the given vessel. This will change at every port call
     * @type {number}
     * @memberof NextPortArrival
     */
    id: number;
    /**
     * Fraction 0..1 of probability. Only present on prediction records.
     * @type {number}
     * @memberof NextPortArrival
     */
    probability?: number;
}

/**
 * Check if a given object implements the NextPortArrival interface.
 */
export function instanceOfNextPortArrival(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "imo" in value;
    isInstance = isInstance && "locode" in value;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function NextPortArrivalFromJSON(json: any): NextPortArrival {
    return NextPortArrivalFromJSONTyped(json, false);
}

export function NextPortArrivalFromJSONTyped(json: any, ignoreDiscriminator: boolean): NextPortArrival {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'imo': json['imo'],
        'eta': !exists(json, 'eta') ? undefined : json['eta'],
        'ata': !exists(json, 'ata') ? undefined : json['ata'],
        'locode': json['locode'],
        'id': json['id'],
        'probability': !exists(json, 'probability') ? undefined : json['probability'],
    };
}

export function NextPortArrivalToJSON(value?: NextPortArrival | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'imo': value.imo,
        'eta': value.eta,
        'ata': value.ata,
        'locode': value.locode,
        'id': value.id,
        'probability': value.probability,
    };
}

